var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[(true)?_c('b-row',{staticClass:"mb-3"},[_c('b-col',{attrs:{"cols":"12"}},[_c('br'),_c('h4',{staticStyle:{"text-align":"center","background":"#cccccc","color":"#fff","padding":"16px 30px","border-radius":"3px 3px 0 0"}},[_vm._v("VEHICLE POSITION")]),_c('br')])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }